import React from 'react';
import { Helmet } from 'react-helmet';

import { Display, Heading, Paragraph } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import BrandFAQSection from '@rover/pages/src/account/BrandActivation/components/frequently-asked-questions/BrandFAQSection';
import { FAQS_SECTION_SUBHEADER_TEXT } from '@rover/pages/src/account/BrandActivation/constants';
import useRoverBrandContext from '@rover/react-lib/src/context/useRoverBrandContext';
import { useCurrentCountryConfiguration } from '@rover/rsdk/src/modules/Data/Core/CountryConfiguration';

import { getBrandWelcomePageConfig } from '../config/brandWelcomePageConfig';

import {
  WELCOME_HEADING,
  WELCOME_PAGE_TITLE_TEXT,
  WELCOME_PARAGRAPH_1,
  WELCOME_PARAGRAPH_2,
  WELCOME_PARAGRAPH_3,
} from './constants';

const CIAFWelcomePage = (): JSX.Element | null => {
  const { brand } = useRoverBrandContext();
  const { data: countryConfig } = useCurrentCountryConfiguration();
  const brandConfig = getBrandWelcomePageConfig(brand, countryConfig);

  return (
    <>
      <Helmet>
        <title>
          {brandConfig.displayName} - {WELCOME_PAGE_TITLE_TEXT()}
        </title>
      </Helmet>

      <Section pt="8x" pb="16x" maxWidth="640px" width="100%">
        <Display size="500" mb="6x">
          {WELCOME_PAGE_TITLE_TEXT()}
        </Display>

        <Heading size="300" mb="6x">
          {WELCOME_HEADING()}
        </Heading>

        <Paragraph mb="4x">{WELCOME_PARAGRAPH_1()}</Paragraph>

        <Paragraph mb="4x">
          {WELCOME_PARAGRAPH_2()} {FAQS_SECTION_SUBHEADER_TEXT(brandConfig.helpCenterUrl)}
        </Paragraph>

        <Paragraph>{WELCOME_PARAGRAPH_3()}</Paragraph>
      </Section>

      <Section background="secondary" maxWidth="640px" py="16x" mb="16x">
        {brandConfig.faqConfig && <BrandFAQSection config={brandConfig.faqConfig} brand={brand} />}
      </Section>
    </>
  );
};

export default CIAFWelcomePage;
